import React from 'react'
import { Route, Routes } from 'react-router-dom'
import { useAuth } from '../context/AuthContext'
// Doctor
import DoctorCheckinAppointmentPage from '../app/doctor/appointments/pages/DoctorCheckinAppointmentPage'
import DoctorCollectionReportPage from '../app/doctor/reports/pages/DoctorCollectionReportPage'
import DoctorDashboardPage from '../app/doctor/dashboard/pages/DoctorDashboardPage'


function DoctorRoutes() {
  return (
    <Routes>
        {/* Doctor */}
        <Route path="/doctor/dashboard" element={<DoctorDashboardPage />}></Route>
        <Route path="/doctor/appointments/checkin" element={<DoctorCheckinAppointmentPage/>}></Route>
        <Route path="/doctor/collection-report" element={<DoctorCollectionReportPage/>}></Route>
    </Routes>
  )
}

export default DoctorRoutes